<template>
    <div class>
        <el-carousel :height="data.height">
            <el-carousel-item v-for="(item, index) in data.banner" :key="index">
                <img :src="item.bannerImgUrl" class="carouse_image_type" alt />
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<style lang="scss" scoped>
    .carouse_image_type{
        width: 100%;
    }
</style>

<script>
import { defineComponent, reactive, onMounted, getCurrentInstance } from "vue";

export default defineComponent({
    name: "banner",
    props:{
        type:{
            type:String,
            default:""
        },
        height:{
            type:Number,
            default:0
        }
    },
    setup(props) {
        
        let { proxy } = getCurrentInstance();

        const data = reactive({
            height: "",
            banner: [{}]
        });

        const handle_set_size = () => {
            let window = document.documentElement.clientWidth;
            let radio = parseFloat(window / 1920).toFixed(6);
            data.height = radio * props.height + "px";
        };

        onMounted(() => {

            handle_set_size();
            window.onresize = () => {
                handle_set_size();
            };

            proxy.$axios
                .get("/banner/get", {
                    params: {
                        code: props.type
                    }
                })
                .then(res => {
                    data.banner = res.data;
                });
        });

        return {
            data
        };
    }
});
</script>